import { Box, Checkbox, ListItem, Stack, Typography } from "@mui/material"
import { grey } from "@mui/material/colors"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import Iconify from "minimals-template/components/Iconify"
import { createSlot } from "lib/@components/slot/create-slot"
import { Bound } from "lib/@components/binding/Bound"
import { isScheduleSelectable } from "../lib/is-schedule-selectable"

export const LockedScheduleInfo = createSlot("LockedScheduleInfo")

export function ScheduleItem({ item }) {
    const { selected, onSelect, lockDataById } = useBoundContext()
    const { label, code, _id } = item

    const lockData = lockDataById?.[_id]
    const { inCurrentProject } = lockData ?? {}

    const hasLockData = !!lockData && typeof lockData === "object"
    const isSelectable = isScheduleSelectable(item, lockDataById)
    const isLocked = !isSelectable

    let checked = !!selected?.[_id]
    if (hasLockData) {
        if (isLocked && inCurrentProject) checked = true
        if (isLocked && !inCurrentProject) checked = false
    }

    return (
        <Bound lockData={lockData}>
            <ListItem sx={{ cursor: "pointer", borderBottom: `1px solid ${grey[200]}` }} data-cy="schedule-item">
                <Box
                    display={"flex"}
                    alignItems={"center"}
                    gap={1}
                    onClick={handleSelect}
                    width={"100%"}
                    sx={{ justifyContent: "space-between", color: !isLocked ? "text.primary" : "text.secondary" }}
                >
                    <Stack direction={"row"} alignItems={"center"} spacing={1}>
                        <Checkbox checked={checked} data-cy="schedule-checkbox" disabled={isLocked} />
                        <Iconify icon={"quill:paper"} sx={{ height: "25px", width: "25px" }} />
                        <Typography flex={1}>{label}</Typography>
                        <LockedScheduleInfo.Slot />
                    </Stack>
                    <Typography variant="body2" sx={{ justifySelf: "flex-end" }}>
                        #{code}
                    </Typography>
                </Box>
            </ListItem>
        </Bound>
    )

    function handleSelect() {
        const { [_id]: deselect, ...remainingSelection } = selected
        !isLocked && onSelect(deselect ? remainingSelection : { ...selected, [_id]: item })
    }
}
